import '../component/Sidebar/Sidebar.css'
import {AdminRoles} from "../context/reducer";

export const RouteHelper = {
    Root: {
        key: "ROOT",
        url: "/",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role, AdminRoles.FUND_MANAGER.role]
    },
    Dashboard: {
        key: "DASHBOARD",
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'ic-dashboard',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Magazine: {
        key: "MAGAZINE",
        name: "تارنما",
        icon: 'ic-magazine',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineList: {
        key: "MAGAZINE_LIST",
        url: "magazine",
        globalUrl: "/panel/magazine",
        name: "آخرین مطالب",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineSlider: {
        key: "MAGAZINE_SLIDER",
        url: "slider",
        globalUrl: "/panel/slider",
        name: "اسلایدر",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineSliderDetail: {
        key: "MAGAZINE_SLIDER_DETAIL",
        url: "slider/:id",
        globalUrl: "/panel/slider/:id",
        name: "جزئیات اسلایدر",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineVideos: {
        key: "MAGAZINE_VIDEOS",
        url: "videos",
        globalUrl: "/panel/videos",
        name: "کلیپ ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineVideoDetail: {
        key: "MAGAZINE_VIDEOS",
        url: "videos/:id",
        globalUrl: "/panel/videos/:id",
        name: "کلیپ ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineVideosDetail: {
        key: "MAGAZINE_VIDEOS_DETAIL",
        url: "videos/:id",
        globalUrl: "/panel/videos/:id",
        name: "جزئیات کلیپ",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineNews: {
        key: "MAGAZINE_NEWS",
        url: "news",
        globalUrl: "/panel/news",
        name: "خبرها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineNewsDetail: {
        key: "MAGAZINE_NEWS_DETAIL",
        url: "news-detail/:id",
        globalUrl: "/panel/news-detail/:id",
        name: "جزئیات خبر",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineCharts: {
        key: "MAGAZINE_CHARTS",
        url: "charts",
        globalUrl: "/panel/charts",
        name: "نمودار ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineChartDetail: {
        key: "MAGAZINE_CHARTS",
        url: "charts/:id",
        globalUrl: "/panel/charts/:id",
        name: "جزئیات نمودار",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineCategory: {
        key: "MAGAZINE_CATEGORY",
        url: "magazine-category",
        globalUrl: "/panel/magazine-category",
        name: "دسته بندی",
        icon: "ic-menu",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineProjects: {
        key: "MAGAZINE_PROJECTS",
        url: "magazine-projects",
        globalUrl: "/panel/magazine-projects",
        name: "پروژه ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineProjectsDetail: {
        key: "MAGAZINE_PROJECTS",
        url: "magazine-projects/:id",
        globalUrl: "/panel/magazine-projects/:id",
        name: "جزئیات پروژه",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    TagList: {
        key: "MAGAZINE_TAGS",
        url: "magazine-tags",
        globalUrl: "/panel/magazine-tags",
        name: "تگ ها",
        icon: "ic-game-play",
        accessRole: []
    },
    FileManager: {
        key: "FILE_MANAGER",
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineWriters: {
        key: "MAGAZINE_WRITERS",
        url: "magazine-writers",
        globalUrl: "/panel/magazine-writers",
        name: "نویسنده ها",
        icon: "ic-menu",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineWriterDetail: {
        key: "MAGAZINE_WRITERS",
        url: "magazine-writers/:id",
        globalUrl: "/panel/magazine-writers/:id",
        name: "جزئیات نویسنده",
        icon: "ic-menu",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    Managers: {
        id: "Managers",
        name: "مدیران",
        icon: "ic-managers",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    ManagersList: {
        key: "MANAGER_LIST",
        url: "managers",
        globalUrl: "/panel/managers",
        name: "لیست مدیران",
        icon: "ic-residence",
        accessRole: []
    },
    Union: {
        key: "UNION",
        url: "union",
        globalUrl: "/panel/union",
        name: "اتحادیه",
        icon: "ic-game-play",
        accessRole: []
    },
    UnionDetail: {
        url: "union/:id",
        globalUrl: "/panel/union/:id",
        name: "جزئیات سرمایه گذاری",
        icon: "ic-game-play",
        accessRole: []
    },
    ContactUs: {
        key: "CONTACTUS",
        url: "contactus",
        globalUrl: "/panel/contactus",
        name: "تماس با ما",
        icon: "ic-conversation",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    Features: {
        key: "FEATURES",
        url: "features",
        globalUrl: "/panel/features",
        name: "ویژگی ها",
        icon: "ic-game-play",
        accessRole: []
    },
    FeatureDetail: {
        key: "FEATURE_DETAIL",
        url: "feature-detail/:id",
        globalUrl: "/panel/feature-detail/:id",
        name: "جزئیات ویژگی",
        icon: "ic-game-play",
        accessRole: []
    },
    Forms: {
        key: "FORMS",
        url: "forms",
        globalUrl: "/panel/forms",
        name: "فرم ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    FormDetail: {
        key: "FORM_DETAIL",
        url: "form/:id",
        globalUrl: "/panel/form/:id",
        name: "جزئیات فرم",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    MagazineDetail: {
        key: "MANAGER_DETAIL",
        url: "magazine/:id",
        globalUrl: "/panel/magazine/:id",
        name: "جزئیات",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    Tour: {
        key: "TOUR",
        name: "تور",
        icon: "ic-tour",
        accessRole: []
    },
    FAQ: {
        key: "FAQ",
        name: "سوالات متداول",
        icon: 'ic-question',
        accessRole: []
    },
    FaqList: {
        key: "FAQ_LIST",
        name: "سوالات متداول",
        url: "faq_list",
        globalUrl: "/panel/faq_list",
        icon: "ic-question",
        accessRole: []
    },
    RulesList: {
        key: "RULES_LIST",
        name: "قوانین",
        url: "rules_list",
        globalUrl: "/panel/rules_list",
        icon: "",
        accessRole: []
    },
    RuleDetails: {
        key: "RULE_DETAILS",
        name: "جزئیات قانون",
        url: "rule-details/:id",
        globalUrl: "/panel/rule-details/:id",
        icon: "",
        accessRole: []
    },
    FaqDetail: {
        key: "FAQ_Detail",
        name: "جزئیات پرسش",
        url: "faq_info/:id",
        globalUrl: "/panel/faq_info/:id",
        icon: "ic-question",
        accessRole: []
    },
    TourFileManager: {
        key: "TOUR_FILE_MANAGER",
        url: "tour-file-manager",
        globalUrl: "/panel/tour-file-manager",
        name: "فایل ها",
        icon: "ic-game-play",
        accessRole: []
    },
    PaymentGateway: {
        key: "PAYMENT_GATEWAY",
        name: "امور مالی",
        icon: 'ic-transactions',
        accessRole: []
    },
    PaymentGatewaysList: {
        key: "PAYMENT_GATEWAYS_LIST",
        name: "درگاه های پرداخت",
        url: "payment-gateways",
        globalUrl: "/panel/payment_gateways",
        icon: "ic-question",
        accessRole: []
    },
    PaymentGatewaysInformation: {
        key: "PAYMENT_GATEWAYS_LIST",
        name: "اطلاعات درگاه پرداخت",
        url: "payment-gateways/:id",
        globalUrl: "/panel/payment-gateways/:id",
        icon: "ic-question",
        accessRole: []
    },
    TransactionsList: {
        key: "TRANSACTIONS_LIST",
        name: "سابقه تراکنشات",
        url: "transactions",
        globalUrl: "/panel/transactions",
        icon: "ic-question",
        accessRole: []
    },
    TransactionDetail: {
        key: "TRANSACTION_DETAIL",
        name: "جزئیات تراکنش",
        url: "transactions/:id",
        globalUrl: "/panel/transactions/:id",
        icon: "",
        accessRole: []
    },
    Users: {
        key: "USERS",
        name: "کاربران",
        icon: 'ic-users',
        accessRole: []
    },
    UsersList: {
        key: "USERS_LIST",
        url: "users-list",
        globalUrl: "/panel/users-list",
        name: "کاربران",
        icon: 'ic-users',
        accessRole: []
    },
    UserInformation: {
        key: "USERS_INFORMATION",
        url: "user-information/:id",
        globalUrl: "/panel/user-information/:id",
        name: "اطلاعات کاربر",
        icon: '',
        accessRole: []
    },
    UsersStatistics: {
        key: "USERS_STATISTICS",
        url: "users-statistics",
        globalUrl: "/panel/users-statistics",
        name: "آمار کاربران",
        icon: '',
        accessRole: []
    },
    Funds: {
        key: "FUNDS",
        name: "صندوق",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    FundsSuperAdmin: {
        key: "FUNDS_Super_ADMIN",
        url: "super-admin",
        globalUrl: "/panel/super-admin",
        name: "مدیر کل",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    FundsList: {
        key: "FUNDS_LIST",
        url: "funds",
        globalUrl: "/panel/funds",
        name: "صندوق ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    FundDetail: {
        key: "FUNDS_LIST",
        url: "fund/:id",
        globalUrl: "/panel/fund/:id",
        name: "جزئيات صندوق",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    FundAdminsList: {
        key: "FUNDS_ADMIN_LIST",
        url: "fund-admins",
        globalUrl: "/panel/fund-admins",
        name: "مدیران",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    FundAdminDetail: {
        key: "FUNDS_ADMIN_LIST",
        url: "fund-admins/:id",
        globalUrl: "/panel/fund-admins/:id",
        name: "جزئیات مدیر صندوق",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    NotificationsList: {
        key: "NOTIFICATIONS_LIST",
        url: "notifications-list",
        globalUrl: "/panel/notifications-list",
        name: "اطلاعیه ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    NotificationsDetail: {
        key: "NOTIFICATION_DETAIL",
        url: "notification-detail/:id",
        globalUrl: "/panel/notification-detail/:id",
        name: "جزئیات اطلاعیه",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.SITE_MANAGER.role]
    },
    Setting: {
        key: "SETTING",
        url: "setting",
        globalUrl: "/panel/setting",
        name: "تنظیمات",
        icon: 'ic-setting',
        accessRole: [AdminRoles.SUPER_ADMIN.role, AdminRoles.FUND_MANAGER.role]
    },
    VersionControl: {
        key: "VERSION_CONTROL",
        url: "version-control",
        globalUrl: "/panel/version-control",
        name: "مدیریت نسخه",
        icon: 'ic-google-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    }
}

export const RouteInfo = {
    Root: {
        url: "/panel",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'ic-game-play',
        accessRole: []
    },
    Dashboard: {
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'ic-dashboard',
        accessRole: []
    },
    MagazineList: {
        url: "magazine",
        globalUrl: "/panel/magazine",
        name: "مجله",
        icon: 'ic-game-play',
        accessRole: []
    },
    TourLeadersList: {
        url: "tour-leader-list",
        globalUrl: "/panel/tour-leader-list",
        name: "تور لیدر ها",
        icon: 'ic-game-play',
        accessRole: []
    },
    Managers: {
        id: "Managers",
        url: "managers",
        globalUrl: "/panel/managers",
        name: "مدیران",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    ManagersList: {
        url: "managers/managers-list",
        globalUrl: "/panel/managers/managers-list",
        name: "مدیران",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    MagazineDetail: {
        url: "magazine/:id",
        globalUrl: "/panel/magazine/:id",
        name: "جزئیات",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    MagazineCategory: {
        url: "magazine-category",
        globalUrl: "/panel/magazine-category",
        name: "دسته بندی",
        icon: "ic-menu",
        accessRole: []
    },
    QUESTIONS: {
        url: "questions",
        globalUrl: "/panel/questions",
        name: "سوالات",
        icon: 'ic-question',
        accessRole: []
    },
    FILE_MANAGER: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-file',
        accessRole: []
    },
    REPORTS: {
        url: "reports",
        globalUrl: "/panel/reports",
        name: "گزارشات",
        icon: 'ic-report',
        accessRole: []
    },
    LEARNS: {
        url: "learns",
        globalUrl: "/panel/learns",
        name: "آموزش ها",
        icon: 'ic-learn',
        accessRole: []
    },
    INFO: {
        url: "info",
        globalUrl: "/panel/info",
        name: "پشتیبانی",
        icon: 'ic-info',
        accessRole: []
    },
    BOX: {
        url: "reports",
        globalUrl: "/panel/reports",
        name: "پیام ها",
        icon: 'ic-box',
        accessRole: []
    },


    Profile: {
        url: "profile",
        globalUrl: "/panel/profile",
        name: "حساب کاربری",
        icon: 'magazine-icon',
        accessRole: []
    },
    SecondItem: {
        url: "second-item",
        globalUrl: "/panel/second-item",
        name: "نمونه جدول",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    DefaultListPage: {
        url: "default-list",
        globalUrl: "/panel/default-list",
        name: "لیست پیشفرض",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    DefaultInputsPage: {
        url: "default-inputs",
        globalUrl: "/panel/default-inputs",
        name: "اینپوت پیشفرض",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Category: {
        url: "category",
        globalUrl: "/panel/category",
        name: "دسته بندی",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    ReleaseDocuments: {
        url: "release-documents",
        globalUrl: "/panel/release-documents",
        name: "اسناد انتشار",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Files: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-game-play',
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Login: {
        url: "panel/login",
        globalUrl: "/panel/login",
        name: "ورود",
        icon: '',
        accessRole: []
    },
    SignInForgetPassword: {
        url: "forget-password",
        globalUrl: "/panel/signIn/forget-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },
    ConfirmPhoneNumber: {
        url: "panel/confirm-phone-number",
        globalUrl: "/panel/confirm-phone-number",
        name: "تایید شماره تماس",
        icon: '',
        accessRole: []
    },
    PasswordRecovery: {
        url: "panel/password-recovery",
        globalUrl: "/panel/password-recovery",
        name: "بازیابی رمز عبور",
        icon: '',
        accessRole: []
    },

    ManagersDetail: {
        url: "managers-detail/:id",
        globalUrl: "/panel/managers-detail/:id",
        name: "جزئيات مدیر",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },

    AppVersionList: {
        url: "app-version-list",
        globalUrl: "/panel/app-version-list",
        name: "نسخه ها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SimpleBarChart: {
        url: "simple-bar-chart",
        globalUrl: "/panel/SimpleBarChart",
        name: "نمودار میله ای ساده",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    PieChartWithPaddingAngle: {
        url: "Pie-chart-with-padding-angle",
        globalUrl: "/panel/Pie-chart-with-padding-angle",
        name: "نمودار دایره ای با فاصله",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    VerticalBarChart: {
        url: "vertical-bar-chart",
        globalUrl: "/panel/vertical-bar-chart",
        name: "نمودار میله ای عمودی",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SimplePieChart: {
        url: "simple-pie-chart",
        globalUrl: "/panel/simple-pie-chart",
        name: "نمودار دایره ای ساده",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    DoughnutChart: {
        url: "doughnut-chart",
        globalUrl: "/panel/doughnut-chart",
        name: "نمودار دونات",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    PieChart: {
        url: "pie-chart",
        globalUrl: "/panel/pie-chart",
        name: "نمودار دایره ای",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Charts: {
        url: "chart-sample",
        globalUrl: "/panel/chart-sample",
        name: "نمودارها",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    Exam: {
        url: "Exam",
        globalUrl: "/panel/Exam",
        name: "امتحان",
        icon: "ic-game-play",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SignIn: {
        url: "panel/signIn/*",
        globalUrl: "/panel/signIn",
        name: "ورود",
        icon: '',
        accessRole: []
    },
    SignInEnterSubmitCode: {
        url: "enter-submit-code",
        globalUrl: "/panel/signIn/enter-submit-code",
        name: "کد تایید",
        icon: '',
        accessRole: []
    },
    SignUp: {
        url: "panel/signUp",
        globalUrl: "/panel/signUp",
        name: "ثبت نام",
        icon: '',
        accessRole: []
    },
    SignUpIntro: {
        url: "/intro",
        globalUrl: "/panel/signUp/intro",
        name: "معرفی",
        icon: '',
        accessRole: []
    },
    SignUpSellerType: {
        url: "/seller-type",
        globalUrl: "/panel/signUp/seller-type",
        name: "نوع فروشنده",
        icon: '',
        accessRole: []
    },
    LegalPerson: {
        url: "/legal-person",
        globalUrl: "/panel/signUp/legal-person",
        name: "فروشنده حقوقی",
        icon: '',
        accessRole: []
    },
    SignInEnterPhoneNumber: {
        url: "enter-phone-number",
        globalUrl: "/panel/signIn/enter-phone-number",
        name: "ورود | ثبت نام",
        icon: '',
        accessRole: []
    },
    SignInRefreshPassword: {
        url: "refresh-password",
        globalUrl: "/panel/signIn/refresh-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },
}

